import { useHistory, useParams } from 'react-router-dom';
import PagePanel from 'components/pagePanel/PagePanel';
import BackButton from 'components/backButton/BackButton';
import React, { useEffect, useState } from 'react';
import { Input, Textarea, RadioGroup, ListDND, Button, RadioButton } from 'components/ui';
import api from 'config/api';
import { pick } from 'lodash';
import { toast } from 'react-toastify';
import { tasks } from '../config/pages';
import ConfirmModal from '../components/confirmModal/ConfirmModal';
import Trash from '../components/svg/Trash';

const Module = () => {
  const history = useHistory();
  const { id } = useParams();
  const isNew = id === 'create';

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [form, setForm] = useState({
    name: '',
    completionText: '',
    description: '',
    status: 'draft',
    tasks: [],
    courses: [],
  });

  const setFormValue = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const setFormModules = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!isNew) {
      api.get(`submodules/${id}`).then(({ data }) => {
        setForm(pick(data, ['name', 'description', 'completionText', 'tasks', 'status', 'courses']));
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [isNew, id]);

  const onSubmit = () => {
    const tasks = form.tasks.map(item => item.id);
    setSaving(true);
    const afterSave = () => {
      toast.success(isNew ? 'Модуль створаны' : 'Модуль захаваны');
    };

    const dataToSend = {
      ...form,
      tasks,
    };

    isNew
      ? api
          .post(`submodules`, dataToSend)
          .then(data => {
            if (data?.data?.id) {
              history.push(`/modules/${data?.data?.id}`);
            }
            afterSave();
          })
          .finally(() => setSaving(false))
      : api
          .patch(`submodules/${id}`, dataToSend)
          .then(afterSave)
          .finally(() => setSaving(false));
  };

  const onDelete = () => {
    api.delete(`submodules/${id}`).then(() => {
      toast.success('Модуль выдалены');
      history.goBack();
    });
  };

  if (loading) return false;

  return (
    <>
      <PagePanel>
        <BackButton />
        {id !== 'create' && (
          <Button color="Red" onClick={() => setShowConfirm(true)} text={'Выдаліць'}>
            <Trash />
          </Button>
        )}
      </PagePanel>
      <div className="page">
        <Input label="Назва модуля*" value={form.name} onChange={e => setFormValue(e, 'name')} />
        <RadioGroup
          line={true}
          className={'width-50'}
          name="status"
          label="Статус"
          value={form.status}
          onChange={e => setFormValue(e, 'status')}
        >
          <RadioButton label="чарнавік" value="draft" />
          <RadioButton label="апублікаваны" value="published" />
        </RadioGroup>

        <Textarea
          label="Апісанне перад праходжаннем"
          value={form.description}
          onChange={e => setFormValue(e, 'description')}
        />
        <Textarea
          label="Апісанне пасля праходжання"
          value={form.completionText}
          onChange={e => setFormValue(e, 'completionText')}
        />

        <ListDND
          type="tasks"
          label="Заданні"
          apiPath={tasks.apiPath}
          tableConfig={tasks.tableConfigDND}
          value={form.tasks}
          onChange={value => setFormModules(value, 'tasks')}
        />
        {form.courses.map(item => item.name)}
        <div className="d-flex flex-end">
          <Button loading={saving} onClick={onSubmit} text={isNew ? 'Стварыць' : 'Захаваць'} />
        </div>
      </div>

      {showConfirm && (
        <ConfirmModal
          onCancel={() => setShowConfirm(false)}
          onConfirm={onDelete}
          text="Вы ўпэўнены, што выдаляем?"
        />
      )}
    </>
  );
};

export default Module;
